export default __webpack_public_path__ + "static/media/logo.27ca1f80.svg";